<template>
  <div id="arrow-down"></div>
</template>

<script>
import lottieWeb from "lottie-web"
export default {
  name: "ArrowDown",
  components: {},
  mounted() {
    lottieWeb.loadAnimation({
      container: document.getElementById("arrow-down"),
      path: "/lottie/arrow.json",
      renderer: "svg",
      loop: true,
      autoplay: true,
      //   name: "Demo Animation",
    })
  },
}
</script>
